import { render, staticRenderFns } from "./InternationalEventsSubscription.vue?vue&type=template&id=6b85cb0e&"
import script from "./InternationalEventsSubscription.vue?vue&type=script&lang=js&"
export * from "./InternationalEventsSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports